<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('productPriceRule.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="productPriceRuleManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input :placeholder="$t('productPriceRule.placeholderRuleId')"
                v-model="productPriceRuleManageInfo.conditions.ruleId">
              </el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-input :placeholder="$t('productPriceRule.placeholderRuleName')"
                v-model="productPriceRuleManageInfo.conditions.ruleName">
              </el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryProductPriceRuleMethod()">
              <i class="el-icon-search"></i>
              {{ $t('common.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('productPriceRule.productPricing') }}</div>
        <el-button type="primary" size="small" @click="_openAddProductPriceRuleModal()">
          {{ $t('common.add') }}
        </el-button>
      </div>
      <div class="">
        <el-table :data="productPriceRuleManageInfo.productPriceRules" style="width: 100%">
          <el-table-column prop="ruleName" :label="$t('productPriceRule.strategyName')" align="center">
          </el-table-column>
          <el-table-column :label="$t('productPriceRule.sellingPrice')" align="center">
            <template slot-scope="scope">
              {{ scope.row.price }}%({{ $t('productPriceRule.basedOn') }}{{ _getBase(scope.row.priceBase) }})
            </template>
          </el-table-column>
          <el-table-column :label="$t('productPriceRule.marketPrice')" align="center">
            <template slot-scope="scope">
              {{ scope.row.otPrice }}%({{ $t('productPriceRule.basedOn') }}{{ _getBase(scope.row.otPriceBase) }})
            </template>
          </el-table-column>
          <el-table-column :label="$t('productPriceRule.memberPrice')" align="center">
            <template slot-scope="scope">
              {{ scope.row.vipPrice }}%({{ $t('productPriceRule.basedOn') }}{{ _getBase(scope.row.vipPriceBase) }})
            </template>
          </el-table-column>
          <el-table-column :label="$t('productPriceRule.ownerPrice')" align="center">
            <template slot-scope="scope">
              {{ scope.row.ownerPrice }}%({{ $t('productPriceRule.basedOn') }}{{ _getBase(scope.row.ownerPriceBase) }})
            </template>
          </el-table-column>
          <el-table-column :label="$t('productPriceRule.propertyDeduction')" prop="deduction" align="center">
          </el-table-column>
          <el-table-column :label="$t('common.operation')" align="center" width="300">
            <template slot-scope="scope">
              <el-button-group>
                <el-button size="mini" @click="_productUpdatePrice(scope.row)">
                  {{ $t('productPriceRule.pricing') }}
                </el-button>
                <el-button size="mini" @click="_openEditProductPriceRuleModel(scope.row)">
                  {{ $t('common.edit') }}
                </el-button>
                <el-button size="mini" type="danger" @click="_openDeleteProductPriceRuleModel(scope.row)">
                  {{ $t('common.delete') }}
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="productPriceRuleManageInfo.conditions.page"
          :page-size="productPriceRuleManageInfo.conditions.row" layout="total, prev, pager, next"
          :total="productPriceRuleManageInfo.total">
        </el-pagination>
      </div>
    </el-card>

    <add-product-price-rule ref="addProductPriceRule" @refresh="_listProductPriceRules"></add-product-price-rule>
    <edit-product-price-rule ref="editProductPriceRule" @refresh="_listProductPriceRules"></edit-product-price-rule>
    <delete-product-price-rule ref="deleteProductPriceRule" @refresh="_listProductPriceRules"></delete-product-price-rule>
    <update-product-price ref="updateProductPrice" @refresh="_listProductPriceRules"></update-product-price>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { listProductPriceRule } from '@/api/goods/productPriceRuleApi'

export default {
  name: 'ProductPriceRuleManage',
  components: {
    'add-product-price-rule': () => import('@/components/goods/addProductPriceRule/addProductPriceRule.vue'),
    'edit-product-price-rule': () => import('@/components/goods/editProductPriceRule/editProductPriceRule.vue'),
    'delete-product-price-rule': () => import('@/components/goods/deleteProductPriceRule/deleteProductPriceRule.vue'),
    'update-product-price': () => import('@/components/goods/updateProductPrice/updateProductPrice.vue')
  },
  data() {
    return {
      productPriceRuleManageInfo: {
        productPriceRules: [],
        total: 0,
        conditions: {
          ruleId: '',
          ruleName: '',
          price: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.productPriceRuleManageInfo.conditions.shopId = getShopId()
    this._listProductPriceRules()
  },
  methods: {
    _listProductPriceRules() {
      listProductPriceRule(this.productPriceRuleManageInfo.conditions)
        .then(response => {
          this.productPriceRuleManageInfo.productPriceRules = response.data
          this.productPriceRuleManageInfo.total = response.records
        })
        .catch(error => {
          console.error('请求失败:', error)
        })
    },
    handleCurrentChange(val) {
      this.productPriceRuleManageInfo.conditions.page = val
      this._listProductPriceRules()
    },
    _openAddProductPriceRuleModal() {
      this.$refs.addProductPriceRule.open()
    },
    _openEditProductPriceRuleModel(row) {
      this.$refs.editProductPriceRule.open(row)
    },
    _openDeleteProductPriceRuleModel(row) {
      this.$refs.deleteProductPriceRule.open(row)
    },
    _queryProductPriceRuleMethod() {
      this.productPriceRuleManageInfo.conditions.page = 1
      this._listProductPriceRules()
    },
    _productUpdatePrice(row) {
      this.$refs.updateProductPrice.open({ ruleId: row.ruleId })
    },
    _getBase(base) {
      if (base === '2') {
        return this.$t('productPriceRule.sellingPrice')
      } else if (base === '3') {
        return this.$t('productPriceRule.marketPrice')
      } else if (base === '4') {
        return this.$t('productPriceRule.ownerPrice')
      } else if (base === '5') {
        return this.$t('productPriceRule.memberPrice')
      }
      return this.$t('productPriceRule.costPrice')
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.card-header-right {
  float: right;
}
</style>